import leftButtonGroupStyle from '../../css/licenses-left-button-group.module.css';

import { ButtonGroup } from 'react-bootstrap';

// Components
import Button from 'components/Button';

import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";


import { isNil, cloneDeep } from "lodash";

const defaultButtonStatus = {
  assignTo: {
    hide: false,
    disabled: true,
  },
  revoke: {
    hide: false,
    disabled: true,
  },
  suspend: {
    hide: false,
    disabled: true,
  },
  resume: {
    hide: false,
    disabled: true,
  },
};

const LeftButtonGroupMSP = ({
  info,
  modalStatus,
  changeModalStatus,
  dataList
}) => {
  const { t } = useTranslation();

  const [buttonStatus, setButtonStatus] = useState(cloneDeep(defaultButtonStatus));


  const handleDisabled = (key) => { // not ready~~
    const copy = cloneDeep(defaultButtonStatus);
    if (info.actions.editInvalid) {
      setButtonStatus(copy);
      return
    }

    for (const item of dataList) {
      if (item.isChecked) {
        for (const [key, data] of Object.entries(copy)) {
          data.disabled = false;
        }
        break;
      }
    }
    setButtonStatus(copy);
  };

  useEffect(() => {
    handleDisabled();
  }, [dataList]);

  return (
    <div
      className={`d-flex justify-content-between ${leftButtonGroupStyle['left-button-group-contianer']}`}
    >
      <ButtonGroup>
        <Button
          label={t('412a9172e0')}
          disabled={buttonStatus.assignTo.disabled}
          onClick={() => changeModalStatus('assignTo', true)}
        ></Button>
        <Button
          label={t('6043697d34')}
          disabled={info.actions?.editInvalid}
          onClick={() => changeModalStatus('addLicense', true)}
        ></Button>
        <Button
          label={t('64c2406bee')}
          disabled={buttonStatus.revoke.disabled}
          onClick={() => changeModalStatus('revoke', true)}
        ></Button>
        <Button
          label={t('f47c23e163')}
          disabled={buttonStatus.suspend.disabled}
          onClick={() => changeModalStatus('suspend', true)}
        ></Button>
        <Button
          label={t('dae71d5bb9')}
          disabled={buttonStatus.resume.disabled}
          onClick={() => changeModalStatus('resume', true)}
        ></Button>
      </ButtonGroup>
    </div>
  );
};

export default LeftButtonGroupMSP;